module.exports = {"id":"210258","name":"Renato Santos","rating":"74","photo":"./data/images/photos/1/210258.png","club":{"name":"Boavista","logo":"./data/images/clubs/Boavista.png"},"positions":["MD","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RenatoSantos0.json
// module id = 3576
// module chunks = 0